
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomHttp, IRequestOptions } from '../http';
import { ConfigServerService } from '../config';

import { BaseEntity } from '../../../models';

/**
 * Service com os métodos de CRUD das entidades
 */
@Injectable({
    providedIn: 'root'
})
export class CrudService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = configServerService.getPathApi();
    }

    search<T extends BaseEntity>(resource: string, options?: IRequestOptions): Observable<T[]> {
        return this.customHttp.get<T[]>(`${this.pathApi}/${resource}`, options);
    }

    find<T extends BaseEntity>(resource: string, id: number, options?: IRequestOptions): Observable<T> {
        return this.customHttp.get<T>(`${this.pathApi}/${resource}/${id}`, options);
    }

    load<T extends BaseEntity>(resource: string, id: number, options?: IRequestOptions): Observable<T> {
        return this.customHttp.get<T>(`${this.pathApi}/${resource}/${id}/load`, options);
    }

    insert<T extends BaseEntity>(resource: string, entity: T, options?: IRequestOptions): Observable<T> {
        return this.customHttp.post<T>(`${this.pathApi}/${resource}`, entity, options);
    }

    update<T extends BaseEntity>(resource: string, entity: T, options?: IRequestOptions): Observable<T> {
        return this.customHttp.put<T>(`${this.pathApi}/${resource}/${entity.id}`, entity, options);
    }

    delete(resource: string, id: number, options?: IRequestOptions): Observable<string> {
        if (!options) {
            options = {};
        }
        // Setando que o retorno do request é um text/plain
        if (!options.responseType) {
            // options.responseType = 'text';
        }

        return this.customHttp.delete<string>(`${this.pathApi}/${resource}/${id}`, options);
    }
}
